import { useReactFlow, Handle, Position, NodeResizer } from "@xyflow/react";
import { InputNumber, Button } from "antd";
import { ClockCircleOutlined, CloseOutlined, CopyOutlined } from "@ant-design/icons";
import NodeNameInput from "./NodeNameInput";

const DelayNode = ({ data, selected, id }) => {
  const { deleteElements } = useReactFlow();
  const update = (patch) => data.onChange?.({ ...data, ...patch });

  const totalSecs =
    (data.days || 0) * 86400 +
    (data.hours || 0) * 3600 +
    (data.minutes || 0) * 60 +
    (data.seconds || 0);

  const summary = totalSecs === 0
    ? "No delay set"
    : totalSecs < 60
      ? `${totalSecs}s`
      : totalSecs < 3600
        ? `${Math.floor(totalSecs / 60)}m ${totalSecs % 60}s`
        : totalSecs < 86400
          ? `${Math.floor(totalSecs / 3600)}h ${Math.floor((totalSecs % 3600) / 60)}m`
          : `${Math.floor(totalSecs / 86400)}d ${Math.floor((totalSecs % 86400) / 3600)}h`;

  return (
    <div style={{
      background: "#fff",
      border: `2px solid ${selected ? "#06b6d4" : "#e5e7eb"}`,
      borderRadius: 10,
      padding: 14,
      minWidth: 260,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      width: "100%",
      height: "100%",
      boxSizing: "border-box",
    }}>
      <NodeResizer minWidth={260} minHeight={80} isVisible={selected} color="#06b6d4" />
      <Handle type="target" position={Position.Left} style={{ background: "#06b6d4" }} />

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <ClockCircleOutlined style={{ color: "#06b6d4", fontSize: 16 }} />
        <strong style={{ fontSize: 13 }}>Delay</strong>
        <Button type="text" size="small" icon={<CopyOutlined />} onClick={() => data.onDuplicate?.()} style={{ marginLeft: "auto", color: "#9ca3af" }} />
        <Button type="text" size="small" icon={<CloseOutlined />} onClick={() => deleteElements({ nodes: [{ id }] })} style={{ color: "#9ca3af" }} />
      </div>

      <div
        className="nodrag"
        onPointerDown={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <NodeNameInput data={data} />
        <p style={{ fontSize: 11, color: "#6b7280", marginBottom: 8 }}>
          Pause flow execution for the specified duration.
        </p>

        <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
          <InputNumber
            value={data.days ?? 0}
            onChange={(v) => update({ days: v ?? 0 })}
            min={0} size="small" style={{ width: 60 }}
            addonAfter={<span style={{ fontSize: 10 }}>d</span>}
          />
          <InputNumber
            value={data.hours ?? 0}
            onChange={(v) => update({ hours: v ?? 0 })}
            min={0} max={23} size="small" style={{ width: 60 }}
            addonAfter={<span style={{ fontSize: 10 }}>h</span>}
          />
          <InputNumber
            value={data.minutes ?? 0}
            onChange={(v) => update({ minutes: v ?? 0 })}
            min={0} max={59} size="small" style={{ width: 60 }}
            addonAfter={<span style={{ fontSize: 10 }}>m</span>}
          />
          <InputNumber
            value={data.seconds ?? 0}
            onChange={(v) => update({ seconds: v ?? 0 })}
            min={0} max={59} size="small" style={{ width: 60 }}
            addonAfter={<span style={{ fontSize: 10 }}>s</span>}
          />
        </div>

        {totalSecs > 0 && (
          <div style={{ fontSize: 10, color: "#6b7280", marginTop: 4 }}>
            = {summary}
          </div>
        )}
      </div>

      <Handle type="source" position={Position.Right} style={{ background: "#06b6d4" }} />
    </div>
  );
};

export default DelayNode;
